/**
 * @module header
 */
(function () {

    const uniNavBtn = document.querySelector(".qld__main-nav__uninav-item-toggle");
    const uniNavMenu = document.querySelector(".qld__main-nav__uninav-sub");
    let isOpen = false;
    
    uniNavBtn?.addEventListener('click', () => {
      isOpen = !isOpen; // Toggle the isOpen state
    
      uniNavBtn.classList.toggle("qld__main-nav__uninav-accordion--open");
      uniNavBtn.classList.toggle("qld__main-nav__uninav-accordion--closed");
      uniNavMenu.classList.toggle("qld__main-nav__uninav-accordion--open");
      uniNavMenu.classList.toggle("qld__main-nav__uninav-accordion--closed");
    });
    
})();

